// extracted by mini-css-extract-plugin
export default {"button":"styles_button__3F7Wx","textButton":"styles_textButton__PvwCC","spinner":"styles_spinner__Mc7hJ"};